// extracted by extract-css-chunks-webpack-plugin
module.exports = {"i3fdetails":"i3fdetails-2VE2Q"};